import React from 'react';

import { useGetReviewExists } from 'entities/notification';
import { useTranslation } from 'react-i18next';

export function WriteReviewButton({
  orderId,
  onOpenReviewDialog,
}: {
  orderId: number;
  onOpenReviewDialog: (orderId: number) => void;
}) {
  const { t } = useTranslation('review');
  const { data, isLoading } = useGetReviewExists(orderId);

  if (isLoading) {
    return null;
  }

  if (data?.memberReviewExists === true) {
    return null;
  }

  return (
    <div className="flex items-center gap-[10px]">
      <button
        type="button"
        onClick={() => {
          onOpenReviewDialog(orderId);
        }}
        className="h-[30px] rounded-[8px] bg-[#222222] px-[12px] text-[13px] font-medium leading-[1.5] tracking-[-0.022em] text-white"
      >
        {t('writeReview.button')}
      </button>
    </div>
  );
}
